module.exports = __webpack_public_path__ + "img/paramo.a263ddb1.png";